<template>
  <div class="backBtn" :style="positionStyle" @click.stop="backFn"></div>
</template>

<script>
import { defineComponent } from 'vue';
import { appPort, mobileApi } from '@/widget/index'
export default defineComponent({
  props: {
    positionStyle: {
      type: Object,
      default: () => {
        return {
          top: '0.24rem'
        }
      }
    }
  },
  methods: {
    backFn () {
      if (this.$attrs.onBackFn) {
        this.$emit('backFn')
        return;
      }
      if (appPort()) {
        const data = { type: "webViewBack" }
        mobileApi(data)
      } else if (this.$route.query.code) {
        // 链接中有
        history.go(-2)
      } else {
        history.go(-1)
      }
    }
  }
})
</script>

<style lang="scss" scoped>
.backBtn {
  position: fixed;
  width: 44px;
  height: 44px;
  display: flex;
  justify-content: center;
  left: 50%;
  margin-left: -375 + 23px;
  z-index: 99;
  border-radius: 50%;
  background: url('~@/assets/icon/icon_light_left.png') no-repeat center;
  background-size: 22px 100%;
}
</style>
